














































import { computed, defineComponent, SetupContext } from "@vue/composition-api";

export default defineComponent({
  name: "form-generic-input-template-v2",
  components: {},
  inheritAttrs: false,
  props: {
    formLabel: {
      type: String,
      default: () => {
        return "";
      },
    },
    formLabelClass: {
      type: String,
      default: () => {
        return "e4s-input--label e4s-flex-row e4s-gap--standard";
      },
    },
    errorMessage: {
      type: String,
      default: () => {
        return "";
      },
    },
    showHelp: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    isRequiredField: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    isRequiredFieldValid: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    showLabel: {
      type: Boolean,
      default: () => {
        //   If false hides the whole label section, which doesn't
        //  really make sense...you'd just dump an input or whatever
        //  on ui...see "hideLabel"
        return true;
      },
    },
    hideLabel: {
      type: Boolean,
      default: () => {
        //  This sets visibility to hidden, so the label + field
        //  still takes up same space...which is most likely
        //  what we are after.
        return false;
      },
    },
    helpText: {
      type: String,
      default: () => {
        return "";
      },
    },
    layoutRowWhenLabelLessThan: {
      type: Number,
      default: () => {
        //  If label short then layout as row.
        //  Default 0 means never and display as column.
        //  3 is a good starting point.
        //  Use with caution, if labels slots used, may need to adjust and css
        //  will need to be adjusted.
        return 0;
      },
    },
  },
  setup(
    props: {
      value: string;
      formLabel: string;
      formLabelClass: string;
      placeHolder: string;
      errorMessage: string;
      showHelp: boolean;
      showLabel: boolean;
      hideLabel: boolean;
      isRequiredField: boolean;
      isRequiredFieldValid: boolean;
      helpText: string;
      layoutRowWhenLabelLessThan: number;
    },
    context: SetupContext
  ) {
    function helpClicked() {
      context.emit("helpClicked");
    }

    const cssForLabel = computed(() => {
      return (
        props.formLabelClass +
        (props.isRequiredField && !props.isRequiredFieldValid
          ? " e4s-input--label-required"
          : "") +
        (props.isRequiredField && props.isRequiredFieldValid
          ? " e4s-input--label-required--is-valid"
          : "")
      );
    });

    const useLayoutRowWhenLabelShort = computed(() => {
      // if props.layoutRowWhenLabelLessThan is zero or less, then never layout as row.
      if (props.layoutRowWhenLabelLessThan <= 0) {
        return false;
      }

      return props.formLabel.length < props.layoutRowWhenLabelLessThan;
    });

    const getRequiredCss = computed(() => {
      const css = [];

      if (useLayoutRowWhenLabelShort.value) {
        css.push("e4s-flex-row");
      } else {
        css.push("e4s-flex-column");
      }

      css.push("e4s-input--container");

      if (props.isRequiredField && !props.isRequiredFieldValid) {
        css.push("xxxxxx");
      }

      return css;
    });

    return {
      cssForLabel,
      getRequiredCss,
      useLayoutRowWhenLabelShort,

      helpClicked,
    };
  },
});
